import { render, staticRenderFns } from "./UserAssignment.vue?vue&type=template&id=357f502c&scoped=true"
import script from "./UserAssignment.vue?vue&type=script&lang=js"
export * from "./UserAssignment.vue?vue&type=script&lang=js"
import style0 from "./UserAssignment.vue?vue&type=style&index=0&id=357f502c&prod&scoped=true&lang=css"
import style1 from "./UserAssignment.vue?vue&type=style&index=1&id=357f502c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f502c",
  null
  
)

export default component.exports